// hooks
import { useMapStoreStateToClientState } from '@/hooks/useMapStoreStateToClientState';

// types
import type { Store } from '@/stores';
import type FlightInfoStore from '@tajawal/web-flights-sdk/lib/stores/flight-info.store';

type ReturnType = {
  $resources: FlightInfoStore['$resources'];
};

export function useStateOfAppProvider(store: Store): ReturnType {
  return useMapStoreStateToClientState(store, (store) => ({
    $resources: store.appStore.flightInfo.$resources,
  }));
}
